import React from "react";

import Toolbar from '@material-ui/core/Toolbar';
import Container from '@material-ui/core/Container';

import StickyFooter from "./footer"
import theLayoutStyles from "./layoutStyles";
import TheAppBar from "../components/appBar";
import { AuthProvider } from "../contexts/AuthContext"



const Layout = ({ children }) => {

  const classes = theLayoutStyles();

  return (
    <div className={classes.root}>
    <AuthProvider>
        <TheAppBar />
        <Container component="main" maxWidth="md" className={classes.main}>
            <Toolbar />
            {children}
        </Container>
        <div className={classes.footer}>
            <StickyFooter/>
        </div>
    </AuthProvider>
    </div>
    )
}
export default Layout